module.exports = __webpack_public_path__ + "img/akk.973a676e.webp";